<template>
    <div class="modalwrapper">
        <blocker :state="state"/>
        <h2>Workflow Viewer</h2>
        <div class="workflowcontainer" :class="{'empty':!$store.state.workflow.steps.length}" :disabled="true">
            <div class="workflow" v-model="$store.state.workflow.steps" :options="{group:'steps', animation: 150, filter: 'input', preventOnFilter: false}">
                <div class="step" :style="{backgroundColor: stepColor[index]}" v-for="(step, index) in $store.state.workflow.steps" :key="step.settings.uid">
                    <div class="action">
                        <svgicon :icon="step.method.toLowerCase()"/><br>
                        <span class="method">{{step.title || step.method}}</span>
                    </div>
                    <component class="properties" :is="step.method" v-model="step.settings" :lastsolvent="null" :solvents="solvents" :uplcfiles="uplcfiles"></component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Centrifugation from './actions/Centrifugation'
import Dispensing from './actions/Dispensing'
import Filtration from './actions/Filtration'
import Extraction from './actions/Extraction'
import Pipetting from './actions/Pipetting'
import Sonication from './actions/Sonication'
import Pause from './actions/Pause'
import Washing from './actions/Washing'
import Weighing from './actions/Weighing'
import HPLC from './actions/HPLC'
import '../icons'

export default {
    methods: {
        ...mapActions([
            'loadWorkflow',
            'importWorkflow'
        ]),
        getWorkflow(){
            this.stepColor = [];
            this.path[0] = this.$attrs.project+'/'+this.$attrs.name+'/Default Batch/Default Condition/'+this.$attrs.vialID;
            this.$api.compatibilityEmit('loadSampleLogs', this.path, (samples)=>{
                this.$set(this, 'sample', samples[0]);            
                this.loadWorkflow(this.sample["workflow file"]);
                this.sample["workflow status"]["workflow steps stati"].slice(1, -1).forEach(step => {
                    this.stepColor.push(this.stepStatus.find(s => s.status.includes(step["step status"])).backgroundColor);
                });
                this.state = 'loaded';
            })    
        },
        getColor(){

        }
    },

    components: {
        Centrifugation,
        Dispensing,
        Filtration,
        Extraction,
        Pipetting,
        Sonication,
        Pause,
        Washing,
        Weighing,
        HPLC
    },

    mounted(){
        this.getWorkflow();
    },

    props: [
        'close'
    ],

    data: function(){
        return {
            solvents: [
                {id: 0, name: 'solvent 0'},
                {id: 1, name: 'solvent 1'},
                {id: 2, name: 'solvent 2'}
            ],
            uplcfiles: [
                'test1.uplcfile',
                'test7.uplcfile',
                'another.uplcfile',
                'lorem.uplcfile',
                'ipsum.uplcfile'
            ],
            path: [],
            sample: {},
            state: '',
            stepStatus: [
                {
                    status: ['undefined','not initialized','disabled','initialized'], 
                    backgroundColor: 'rgba(102, 102, 102, 0.2)'  //grey
                },
                {
                    status: ['on hold','userwait', 'planned','scheduled','prequeued','queued'], 
                    backgroundColor: 'rgba(255, 255, 0, 0.2)'  //yellow
                },
                {
                    status: [,'started','preparing','resetting','running','holding','finishing'], 
                    backgroundColor: 'rgba(0, 255, 0, 0.2)'  //green
                },
                {
                    status: ['blocking','aborting','error','aborted'], 
                    backgroundColor: 'rgba(255, 0, 0, 0.2)'  //red
                },                
                {
                    status: ['skipped','completed'], 
                    backgroundColor: 'rgba(0, 100, 255, 0.2)'  //blue
                },
            ],
            stepColor: [],
        }
    }
}

</script>

<style lang="scss" scoped>
    @import "../colors.scss";
    .modalwrapper {
        padding: 10px; 

    }
    .workflowcontainer {
        grid-area: workflow;
        overflow-y: scroll;
        overflow-x: hidden;
        height: 390px;
    }
    .workflow {
        padding-bottom: 100px;
                pointer-events: none;
    }
    .action {
        border-radius: 2px;
        height: 80px;
        width: 80px;
        text-align: center;
        margin: 3px;
        display: inline-block;
        position: relative;

        .svg-icon {
            height: 45px;
            margin-top: 11px;
        }
        .method {
            font-size: 1rem;
        }
    }
    .step {
        border-radius: 2px;
        box-shadow: 2px 2px 5px -2px $accromagrey;
        .properties {
            display: inline-block;
            padding: 4px;
            vertical-align: top;
        }
        margin: 7px;
        font-size: 1rem;
    }
</style>
